module.exports = __webpack_public_path__ + "img/logo-trans.3484f9c1.png";